import {
  FETCH_MYSESSION_DATA,
  FETCH_MYSESSION_LIVEQA_DATA,
  SHOW_ACCESS_SESSION,
  OPEN_QA_SESSION
} from '../actions';

export function mySessionDataReducers(state = {}, action) {
  switch (action.type) {
    case FETCH_MYSESSION_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function mySessionqaDataReducer(state = {}, action) {
  if (action.type === FETCH_MYSESSION_LIVEQA_DATA) {
    return action.payload;
  }
  return state;
}

export function showAceessSession(state = false, action) {
  if (action.type === SHOW_ACCESS_SESSION) {
    return action.payload;
  }
  return state;
}

export function openqaReducer_session(state = false, action) {
  if (action.type === OPEN_QA_SESSION) {
    return action.payload;
  }
  return state;
}
